import React from "react";

const LazyBoardSettings = React.lazy(() => import("./BoardSettings").then((m) => ({ default: m.BoardSettings })));

export default LazyBoardSettings;
